var activeLockCount = 0;
var lockState = null;

function getPaddingProperty(body, computedStyle) {
  if ('paddingInlineEnd' in body.style) {
    return 'paddingInlineEnd';
  }
  return computedStyle && computedStyle.direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
}

function applyLock() {
  var body = document.body;
  var documentElement = document.documentElement;
  var computedStyle = window.getComputedStyle ? window.getComputedStyle(body) : null;
  var paddingProperty = getPaddingProperty(body, computedStyle);
  var originalInlinePadding = body.style[paddingProperty];
  var computedPadding = computedStyle ? parseFloat(computedStyle[paddingProperty]) : 0;
  var widthBeforeLock = documentElement.clientWidth;

  if (!Number.isFinite(computedPadding)) {
    computedPadding = 0;
  }

  lockState = {
    body: body,
    hadOverflowHidden: body.classList.contains('overflow-hidden'),
    paddingProperty: paddingProperty,
    originalInlinePadding: originalInlinePadding
  };

  body.classList.add('overflow-hidden');

  // A stable CSS scrollbar gutter keeps these widths equal. Older browsers
  // widen the viewport here, so preserve that space with matching padding.
  var widthAfterLock = documentElement.clientWidth;
  var scrollbarCompensation = Math.max(0, widthAfterLock - widthBeforeLock);
  if (scrollbarCompensation > 0) {
    body.style[paddingProperty] = (computedPadding + scrollbarCompensation) + 'px';
  }
}

function removeLock() {
  if (!lockState) return;

  var state = lockState;
  lockState = null;
  state.body.style[state.paddingProperty] = state.originalInlinePadding;
  if (!state.hadOverflowHidden) {
    state.body.classList.remove('overflow-hidden');
  }
}

function acquire() {
  if (typeof document === 'undefined' || !document.body || !document.documentElement || typeof window === 'undefined') {
    return function () {};
  }

  var released = false;
  activeLockCount++;
  if (activeLockCount === 1) {
    applyLock();
  }

  return function release() {
    if (released) return;
    released = true;
    activeLockCount = Math.max(0, activeLockCount - 1);
    if (activeLockCount === 0) {
      removeLock();
    }
  };
}

module.exports = {
  acquire: acquire
};
